export default {
  formValidation: {
    emptyField: 'Pole nemůže být prázdné',
    requiredField: 'Pole je povinné',
    passwordToShort: 'Heslo musí mít 8 znaků',
    emailNotValid: 'Pole musí obsahovat platnou e-mailovou adresu',
    emailReserved: 'E-mailová adresa je již obsazena',
    rateEmpty: 'Všechna pole musí být vyplněna',
    serverUnknownError: 'Chyba komunikace se serverem',
    invalidCharacters: 'Pole obsahuje neplatné znaky',
    phoneNotValid: 'Telefonní číslo je nesprávné',
    checkBoxBelow: 'Pro odeslání zprávy zaškrtněte políčko níže',
  },
  password: {
    show: 'zobrazit',
    hide: 'skrýt',
  },
  howItWorks: {
    showButton: 'Zobrazit více',
    hideButton: 'Zobrazit méně',
  },
}
